<template>
  <el-dialog
      :visible.sync="dialogVisible"
      width="720px"
      top="6vh"
      append-to-body
      :close-on-click-modal="false"
      custom-class="transfer-dialog"
      @close="handleClose"
  >
    <div slot="title" class="transfer-dialog__header">
      <div class="transfer-dialog__header-icon">
        <i class="el-icon-s-promotion"></i>
      </div>
      <div class="transfer-dialog__header-text">
        <div class="transfer-dialog__header-title">成果转化</div>
        <div v-if="formzr.achievementName" class="transfer-dialog__header-sub">
          {{ formzr.achievementName }}
        </div>
      </div>
    </div>

    <div class="transfer-dialog__body">
      <el-form
          ref="formzrRef"
          :model="formzr"
          :rules="formRules"
          label-position="top"
          class="transfer-form"
      >
        <el-input v-model="formzr.userId" style="display: none;"/>
        <el-input v-model="formzr.userName" style="display: none;"/>
        <el-input v-model="formzr.id" style="display: none;"/>

        <section class="transfer-section">
          <div class="transfer-section__title">
            <span class="transfer-section__dot"></span>
            转化信息
          </div>
          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item label="转化类型" prop="transferType">
                <el-select
                    v-model="formzr.transferType"
                    placeholder="请选择转化类型"
                    style="width: 100%;"
                >
                  <el-option
                      v-for="item in currentTransferTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="转化时间" prop="transferTime">
                <el-date-picker
                    v-model="formzr.transferTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期"
                    style="width: 100%;"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item label="转化金额（万元）" prop="receiveMoney">
                <el-input v-model="formzr.receiveMoney" placeholder="请输入转化金额">
                  <template slot="prepend">¥</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="技术经理人" prop="technicalManager">
                <el-select
                    v-model="formzr.technicalManager"
                    filterable
                    allow-create
                    clearable
                    placeholder="请选择或输入"
                    style="width: 100%;"
                >
                  <el-option
                      v-for="item in technicalManagerList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.name"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </section>

        <section class="transfer-section">
          <div class="transfer-section__title">
            <span class="transfer-section__dot"></span>
            接收方信息
          </div>
          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item label="接收单位/人" prop="receiveName">
                <el-input v-model="formzr.receiveName" placeholder="请输入接收单位/人"/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="接收方账号" prop="receiveAccount">
                <el-input v-model="formzr.receiveAccount" placeholder="请输入账号"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item label="联系电话" prop="receivePhone">
                <el-input v-model="formzr.receivePhone" placeholder="请输入联系电话"/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="所属区县" prop="areaCodeval">
                <el-select
                    v-model="formzr.areaCodeval"
                    placeholder="请选择区县"
                    style="width: 100%;"
                    @change="handleAreaCodeChange"
                >
                  <el-option
                      v-for="item in areaCodeArray"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </section>

        <section class="transfer-section transfer-section--upload">
          <div class="transfer-section__title">
            <span class="transfer-section__dot"></span>
            转让协议
          </div>
          <el-form-item prop="uploadImg" class="transfer-upload-item">
            <el-upload
                class="transfer-upload"
                drag
                :action="UPLOAD_IMAGE_URL"
                :headers="uploadHeaders"
                :accept="UPLOAD_ACCEPT"
                :before-upload="beforeUploadAuth"
                :on-success="onTransferUploadSuccess"
                :on-remove="handleFileRemoveImg"
                :limit="1"
                :on-exceed="handleExceed"
                :file-list="fileList"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将协议文件拖到此处，或<em>点击上传</em></div>
              <div class="el-upload__tip" slot="tip">支持常见文档/图片格式，仅可上传 1 个文件</div>
            </el-upload>
            <div v-if="showimg" class="transfer-preview">
              <img :src="showimg" alt="协议预览"/>
            </div>
          </el-form-item>
        </section>
      </el-form>
    </div>

    <div slot="footer" class="transfer-dialog__footer">
      <el-button size="medium" @click="handleClose">取 消</el-button>
      <el-button size="medium" type="primary" icon="el-icon-check" @click="handleSubmit">
        确定转化
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { Message } from "element-ui";
import {
  getUploadHeaders,
  UPLOAD_IMAGE_URL,
  UPLOAD_ACCEPT,
  beforeUploadAuth,
  parseUploadResponse,
  promptReLogin
} from "@/config/upload";

export default {
  name: "TransferFormDialog",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    formzr: {
      type: Object,
      required: true
    },
    formRules: {
      type: Object,
      default: () => ({})
    },
    currentTransferTypeList: {
      type: Array,
      default: () => []
    },
    technicalManagerList: {
      type: Array,
      default: () => []
    },
    areaCodeArray: {
      type: Array,
      default: () => []
    },
    fileList: {
      type: Array,
      default: () => []
    },
    showimg: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      UPLOAD_IMAGE_URL,
      UPLOAD_ACCEPT,
      beforeUploadAuth
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    },
    uploadHeaders() {
      return getUploadHeaders();
    }
  },
  methods: {
    handleAreaCodeChange(val) {
      this.$emit("area-code-change", val);
    },
    onTransferUploadSuccess(response, file, fileList) {
      const result = parseUploadResponse(response);
      if (!result.ok) {
        if (result.expired) promptReLogin();
        else Message.error(result.msg);
        return;
      }
      this.$emit("upload-success", { newName: result.data.newName, fileList });
    },
    handleFileRemoveImg(file, fileList) {
      this.$emit("file-remove", fileList);
    },
    handleExceed() {
      this.$message.warning("只能上传一个文件，请先移除已有的文件再上传新的文件");
    },
    handleClose() {
      this.$emit("update:visible", false);
      this.$emit("close");
    },
    handleSubmit() {
      this.$refs.formzrRef.validate((valid) => {
        if (valid) {
          this.$emit("submit");
        } else {
          this.$message.error("请检查必填的数据");
        }
      });
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/css/transfer-dialog.scss";
</style>
